"use client";

import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

const tagKeys = [1, 2, 3, 4, 5, 6] as const;

export function LandingShowcaseCarousel() {
  const t = useTranslations("landing");
  const { resolvedTheme } = useTheme();
  const textRef = useScrollReveal<HTMLDivElement>({ animation: "fade-in-left" });
  const imageRef = useScrollReveal<HTMLDivElement>({ animation: "fade-in-right" });

  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid items-center gap-12 md:grid-cols-2">
          {/* Text */}
          <div ref={textRef}>
            <h2 className="text-3xl font-bold tracking-tight text-ink sm:text-4xl">
              {t("showcaseCarousel.heading1")}
              <br />
              <span className="font-serif italic text-mint">
                {t("showcaseCarousel.heading2")}
              </span>
            </h2>
            <p className="mt-4 text-landing-muted leading-relaxed">
              {t("showcaseCarousel.description")}
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {tagKeys.map((n) => (
                <span
                  key={n}
                  className="rounded-full border border-landing-border bg-landing-card px-3 py-1 text-xs text-landing-muted"
                >
                  {t(`showcaseCarousel.tag${n}`)}
                </span>
              ))}
            </div>
          </div>

          {/* Phone mockup */}
          <div className="flex justify-center" ref={imageRef}>
            <img
              src={resolvedTheme === "dark" ? "/mockups/carousel-editor.png" : "/mockups/carousel-editor-light.png"}
              alt="Mint24 — редактор каруселей для Instagram и Telegram"
              className={resolvedTheme === "dark" ? "h-[420px] w-auto rounded-3xl sm:h-[520px]" : "h-[420px] w-auto sm:h-[520px]"}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
